import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, timer } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { environment } from '../../environments/environment.prod';

import { JwtHelper } from '../core/models/jwt-helper';
import { IdToken } from '../core/models/login.model';
import { ToastrService } from 'ngx-toastr';
import { SignalRService } from '../core/services/signalR.service';
import { HttpClient } from '@angular/common/http';
import { BankPortalAuthService } from '../core/services/bankportal-auth.service';
import { Errors } from '../core/models/errors.model';
import { AuthGuard } from '../core/services/auth-guard.service';
@Component({
  selector: 'app-auth-page',
  templateUrl: './auth.component.html',
  styleUrls: ['./login.scss']
})
export class AuthComponent implements OnInit {
  authType: string = '';
  title: string = '';
  deploymentType!: string;
  errors: Errors = { errors: {} };
  submitted = false;
  authForm: UntypedFormGroup;
  timersession = timer(4000, 60000);
  isSessionExpired = false;
  public isLoggedIn$!: Observable<boolean>;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: UntypedFormBuilder,
    private _authService: AuthGuard,
    private toaster: ToastrService,
    private signalRService: SignalRService,
    private _bankPortalAuthService: BankPortalAuthService

  ) {
    // use FormBuilder to create a form group
    this.authForm = this.fb.group({
      userName: ['', Validators.required],
      password: ['', Validators.required],
    });
    this._authService.isLoggedIn = false;
    this._authService.userName = "";

  }
  get f() { return this.authForm.controls; }

  ngOnInit() {
   // this.isLoggedIn$ = this._bankPortalAuthService.isLoggedIn$;
    this.deploymentType = environment.deploymentType;
    //this.route.url.subscribe(data => {
    //  // Get the last piece of the URL (it's either 'login' or 'register')
    //  this.authType = data[data.length - 1].path;
    //  // Set a title for the page accordingly
    //  this.title = (this.authType === 'login') ? 'Sign in' : 'Sign up';
    //  // add form control for username if this is the register page
    //  if (this.authType === 'register') {
    //    this.authForm.addControl('username', new FormControl());
    //  }
    //});

  }

  expireSession() {
    this.timersession.pipe(
      takeWhile(x => this.isSessionExpired === false)
    ).subscribe(
      () => {

        const token = localStorage.getItem('idToken');
        if (token !== null) {
          const jwtHelper = new JwtHelper();
          const decodedIdToken = <IdToken>jwtHelper.decodeToken(token);
          const expire = decodedIdToken.exp;
          if (Date.now() >= expire * 1000) {
            this.isSessionExpired = true;
            this.toaster.info("Session Expired", "Your Session has expired. Please log in again", { timeOut: 10000 })
            this.router.navigate(['/']);
            localStorage.clear();
          }
          else {
            this.isSessionExpired = false;
          }
        }
        else {
          this.router.navigate(['/']);
          localStorage.clear();
          this.isSessionExpired = true;
        }

      });
  }

  submitForm() {
    this.submitted = true;
    this.errors = { errors: {} };
    if (this.authForm.invalid) {
      this.toaster.warning("Error","Unable to login invalid credentials");
      return;
    }
    this. _bankPortalAuthService.login(this.authForm.value.userName, this.authForm.value.password);
    
    this.submitted = false;

  }
  LoginMessage() {
    this.signalRService.startConnection();
    this.isSessionExpired = false;
    this.toaster.success("","Login Successful");
    this.router.navigateByUrl('/home');
    this.expireSession();
  }
}
